import React from 'react';
import { arraySpacingX as tooltip } from 'pu-data/Tooltips';
import TextComponent from './TextComponent';

const ArraySpacingY = (props) => {
  const name = 'array_spacing_y';
  const onChange = (e) => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label="Spacing Y"
      name={name}
      value={props.parameters[name] || ''}
      onChange={props.onChange || onChange}
      tooltip={tooltip}
      groupName={props.groupName} />
  );
};

ArraySpacingY.defaultProps = {};

export default ArraySpacingY;
